import config from '../config'
import { md5 } from './strings'

const MediaUtils = {
    /**
     * @deprecated
     */
    readFile(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()

            reader.onabort = () => reject(new Error('Reading aborted'))
            reader.onerror = () => reject(new Error('file reading has failed'))
            reader.onload = () => {
                const binaryStr = reader.result
                resolve(binaryStr)
            }

            reader.readAsBinaryString(file, 'utf8')
        })
    },

    /**
     * @deprecated
     */
    checksum(content) {
        return md5(content)
    },

    isBeingUploaded(media) {
        if (!media) {
            return false
        }

        const { date_upload_started, date_upload_ended } = media

        return (
            (date_upload_started || date_upload_ended) && // this prevents to send true if both dates are null (old entries)
            date_upload_started &&
            !date_upload_ended
        )
    },

    isAudio(media) {
        if (!media || typeof media !== 'object') {
            return true
        }

        const { type } = media

        return type && type.includes('audio')
    },

    isVideo(media) {
        if (!media || typeof media !== 'object') {
            return true
        }

        const { type } = media

        // If type doesn't exist, treat media as a video by default
        if (!type) {
            return true
        }

        return type.includes('video')
    },

    hasFailedUpload(media) {
        if (!media) {
            return false
        }

        const { date_upload_started, date_upload_ended } = media

        return !!date_upload_started && !date_upload_ended && new Date().getTime() - date_upload_started > config.uploads.timeToFailUpload
    },

    getVideoResolution(file) {
        const url = URL.createObjectURL(file)
        return new Promise((resolve) => {
            const video = document.createElement('video')
            video.onloadedmetadata = (evt) => {
                URL.revokeObjectURL(url)
                resolve({ width: video.videoWidth, height: video.videoHeight })
            }
            video.src = url
            video.load()
        })
    },

    getImageResolution(file) {
        const img = document.createElement('img')
        return new Promise((resolve) => {
            img.onload = function (event) {
                resolve({ width: img.width, height: img.height })
            }

            img.src = URL.createObjectURL(file)
        })
    },

    async getMediaResolution(media) {
        const { width = 0, height = 0 } = this.isVideo(media) ? await this.getVideoResolution(media) : await this.getImageResolution(media)
        return { width, height }
    },

    getVideoDuration(file) {
        const video = URL.createObjectURL(file)
        return new Promise((resolve) => {
            const audio = new Audio()
            audio.src = video
            audio.onloadedmetadata = (_) => {
                resolve({ duration: audio.duration })
            }
            audio.onerror = (ev) => {
                console.log('error', ev)
            }
        })
    },

    async getMediaDuration(media) {
        const { duration } = this.isVideo(media) ? await this.getVideoDuration(media) : { duration: 1 }
        return duration
    },
}

export default MediaUtils
